var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamlineIconTargetCenter1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.37 15a3.75 3.75 0 1 1-3.74-3.75",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.86 13a7.78 7.78 0 0 1 .26 2A7.47 7.47 0 1 1 11 7.88M8.63 15l6.82-6.83M1.13 23.25l2.58-2.59m12.41 2.59-2.58-2.58m6.15-12.5a1.46 1.46 0 0 1-1.27.43l-3-.43L15 5.2a1.51 1.51 0 0 1 .42-1.27L18.63.75l.91 3.34 3.33.9Z",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconTargetCenter1);
export default __webpack_public_path__ + "static/media/streamline-icon-target-center-1.678ff38a.svg";
export { ForwardRef as ReactComponent };